import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
import { isActivePath } from "../../../Shared/utils/browser";
import { Link } from "../../custom_components/components/library/link";
export const menuLink = (x, handle)=>{
    const isActive = !x.external && isActivePath(x.relative);
    const props = {
        className: `menu__link ${isActive ? 'menu__link--active' : ''}`,
        url: x.external ? x.absolute : x.relative,
        handle
    };
    return /*#__PURE__*/ _jsx(Link, {
        ...props,
        children: x.title
    }, x.key);
};
export default menuLink;
